// Grymwyrd marketing copy — French (fr). Localized for immersive tabletop RPG experience.
export const marketingFr = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Quickstart gratuit',
  'marketing.free.seo.description':
    'Reçois le Quickstart Grymwyrd gratuit — les règles et un scénario one-shot à mener dès ce soir. Entre dans le Crépuscule.',
  'marketing.free.eyebrow': 'Ton passage gratuit',
  'marketing.free.heading': 'Entre dans le Crépuscule — gratuitement',
  'marketing.free.subheadLead': 'Le',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— les règles de base plus un scénario one-shot que tu peux mener dès ce soir. Dis-nous où l\'envoyer.',
  'marketing.free.benefit.rules.title': 'Les règles',
  'marketing.free.benefit.rules.body': 'Tout ce qu\'il te faut pour jouer, condensé dans un quickstart.',
  'marketing.free.benefit.oneShot.title': 'Un scénario one-shot',
  'marketing.free.benefit.oneShot.body': 'Une aventure d\'horreur prête à jouer pour ta première nuit.',
  'marketing.free.benefit.livingWorld.title': 'Un monde vivant',
  'marketing.free.benefit.livingWorld.body': 'Des crochets narratifs vers une encyclopédie, des cartes et des sorties hebdomadaires.',
  'marketing.free.playInstead.heading': 'Tu préfères jouer maintenant ?',
  'marketing.free.playInstead.body':
    'Forge ton premier personnage et lance un essai solo de 10 minutes — sans achat, sans engagement.',
  'marketing.free.playInstead.cta': 'Forger un personnage',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Un problème est survenu. Réessaie dans un instant.',
  'marketing.leadForm.ready': 'Ton Quickstart gratuit est prêt.',
  'marketing.leadForm.downloadCta': 'Télécharge ton Quickstart',
  'marketing.leadForm.alsoEmailed': 'Nous avons aussi envoyé le lien dans ta boîte de réception.',
  'marketing.leadForm.checkInbox': 'Consulte ta boîte de réception — ton Quickstart gratuit arrive.',
  'marketing.leadForm.emailPlaceholder': 'toi@exemple.com',
  'marketing.leadForm.emailAriaLabel': 'Adresse e-mail',
  'marketing.leadForm.defaultCta': 'Envoie-moi le Quickstart',
  'marketing.leadForm.privacyNote':
    'Pas de spam — juste le Quickstart et, de temps en temps, une bribe de lore. Désabonnement possible à tout moment.',
} as const
